import { Form, Row, Col } from "antd"
import { useEffect, useMemo, useState } from "react"
import { Commons, Const } from "./constants";
import { SaveButton, InputText, CancelButton, ModalComponent, trans, SelectWithSearch, AddNewButton } from "@comps/components"
import { createSelectList } from '@comps/commonFunctions';
import CreateEncashmentType from '../policyManagement/settings/encashmentTypes/components/CreateEncashmentType';
import CreateDeductionType from '../policyManagement/settings/deductionTypes/components/CreateDeductionType';
import { makeFieldLabel } from "@utils/fieldTooltips";
import { getSlabTooltips } from "../policyManagement/common/policyTooltips";
const langKey = Const["policySlab"].lngKey
const formName = "createPolicySlab";
const CreatePolicySlab = (props) => {
  // Slab wording depends on the policy the slab belongs to: late minutes,
  // overtime minutes, and absence counts all use the same fields.
  const slabLabel = useMemo(
    () => makeFieldLabel(getSlabTooltips(props.policyType), { namespace: "createPolicySlab", label: (key) => trans(`${langKey}.${key}`) }),
    [props.policyType]
  );

  const [deductionTypes, setDeductionTypes] = useState([])
  const [encashmentTypes, setEncashmentTypes] = useState([])
  const [fromSalary, setFromSalary] = useState(false)
  const [repeatTypes,setRepeats]=useState([]);
  const [childComponent, setChildComponent] = useState(null);
  const [fallBackTypes,setFallbackTypes]=useState([]);
  const [form] = Form.useForm()
  useEffect(() => {
    getRelatedData()
    // eslint-disable-next-line
  }, []);

  const getRelatedData = () => {
    if (props.policyType === 'overtime' || props.policyType === 'cpl') {
      setEncashmentTypes(createSelectList(props.allData.encashment_types))
      //setEncashmentTypesAll(props.allData.encashment_types)
    }
    else {
      //setDeductionTypesAll(props.allData.deduction_types)
      setDeductionTypes(createSelectList(props.allData.deduction_types))
      setRepeats(createSelectList(props.allData.repeats))
    }
  }

  const onChangeDeductionType = (id) => {
    let fallbacks=[];
    if (props.policyType === 'overtime' || props.policyType === 'cpl') {
      props.allData.encashment_types.forEach(each => {
        if (each.id === id) {
          setFromSalary(each.from_salary)
        }
        if(each.from_salary){
          fallbacks.push(each)
        }
      })

    }
    else {
      props.allData.deduction_types.forEach(each => {
        if (each.id === id) {
          setFromSalary(each.from_salary)
        }
        if(each.from_salary){
          fallbacks.push(each)
        }
      })
    }

setFallbackTypes(createSelectList(fallbacks));
  }
  const onSubmit = (data) => {
    props.onCompleted(data, 'Added')
  }

  const onAddChild = (field) => {
    if (field === 'encashment_type_id') {
      setChildComponent(<CreateEncashmentType onCompleted={ (data) => onChildCreated(data, field) } />)
    }
    if (field === 'fallback_type_id' || field === 'deduction_type_id') {
      setChildComponent(<CreateDeductionType onCompleted={ (data) => onChildCreated(data, field) } />)
    }

  }
  const onChildCreated = (data, field) => {
    if (data.length) {

      if (field === 'encashment_type_id') {
        setEncashmentTypes(createSelectList(data))
      }
      if (field === 'fallback_type_id' || field === 'deduction_type_id') {
        setDeductionTypes(createSelectList(data))
      }
      form.setFieldValue(field, data[0].id)
    }
    setChildComponent(null);
  }


  const footer = [
    <SaveButton form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];
  return (

    <ModalComponent top={ 20 } width={ 1000 } maskClosable={ false }
      mainTitle={ trans(Commons.create) } subTitle={ trans(`${langKey}.moduleName`) }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>
      { childComponent }
      <Form { ...formLayout } name={ formName } onFinish={ onSubmit } form={ form } scrollToFirstError>
        <Row gutter={ 30 }>
          {
            props.fields.map((field) => (
              field.type === 'text' || field.type === 'number' ?
                <Col lg={ 12 } sm={ 24 } xs={ 24 }>

                  <Form.Item name={ field.name } rules={ rules[field.name] } label={ slabLabel(field.name) }

                  >
                    <InputText type={ field.type } placeholder={ trans(`${langKey}.${field.name}`) } />
                  </Form.Item>
                </Col>
                :
                field.name === 'repeat_id' ?


                  <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                    <Form.Item name={ field.name } rules={ rules[field.name] } label={ slabLabel(field.name) }
                    >
                      <SelectWithSearch options={ field.options } placeholder={ trans(`${langKey}.${field.name}`) } />
                    </Form.Item>
                  </Col>
                  :
                  field.name === 'deduction_type_id' ?
                    <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                      <div className="klok-field-action">
                        <Form.Item name={ field.name } rules={ rules[field.name] } label={ slabLabel(field.name) }
                        >
                          <SelectWithSearch options={ deductionTypes } onChange={ field.name === 'deduction_type_id' ? onChangeDeductionType : null } placeholder={ trans(`${langKey}.${field.name}`) } />
                        </Form.Item>
                        <AddNewButton text={ field.name } onClick={ () => onAddChild(field.name) } />
                      </div>
                    </Col>
                    :
                    field.name === 'encashment_type_id' ?
                      <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                        <div className="klok-field-action">
                          <Form.Item name={ field.name } rules={ rules[field.name] } label={ slabLabel(field.name) }
                          >
                            <SelectWithSearch options={ encashmentTypes } onChange={ field.name === 'encashment_type_id' ? onChangeDeductionType : null } placeholder={ trans(`${langKey}.${field.name}`) } />
                          </Form.Item>
                          <AddNewButton text={ field.name } onClick={ () => onAddChild(field.name) } />
                        </div>
                      </Col>
                      :
                      !fromSalary && field.name === 'fallback_type_id' ?
                        <Col lg={ 12 } sm={ 24 } xs={ 24 }>
                          <div className="klok-field-action">
                            <Form.Item name={ field.name } rules={ rules[field.name] } label={ slabLabel(field.name) }
                            >
                              <SelectWithSearch options={ fallBackTypes } placeholder={ trans(`${langKey}.${field.name}`) } />
                            </Form.Item>
                            <AddNewButton text={ field.name } onClick={ () => onAddChild(field.name) } />
                          </div>
                        </Col>
                        : ''

            ))
          }
        </Row>

      </Form>
    </ModalComponent>

  )
}
export default CreatePolicySlab
const formLayout = {
  layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
}
const rules = {
  min_times: [
    { required: true, message: trans(`${langKey}.min_times.req`) },
  ],
  min: [
    { required: true, message: trans(`${langKey}.min.req`) },
  ],
  max: [
    { required: true, message: trans(`${langKey}.max.req`) },
  ],
  start_mins: [
    { required: true, message: trans(`${langKey}.start_mins.req`) },
  ],
  repeat_id: [
    { required: true, message: trans(`${langKey}.repeat_id.req`) },
  ],
  deduction_type_id: [
    { required: true, message: trans(`${langKey}.deduction_type_id.req`) },
  ],
  fallback_type_id: [
    { required: true, message: trans(`${langKey}.fallback_type_id.req`) },
  ],

}

//required props
//!slab.deduction_type.from_salary (fallback type)
